import React, {useEffect, useState} from "react";
import Util from "../Util";
import Dispatcher from "../dispatcher";
import {FluxEvent, Permission} from "../Enums";
import {Alert, Button, Form, InputGroup} from "react-bootstrap";
import LicenceDetails from "./LicenceDetails";
import UlpsPortalApiClient from "../UlpsPortalApiClient";
import store from "../store";
import LicenceTable from "../components/LicenceTable";

export default function LicenceSearch() {
  const [id, setId] = useState(Util.getQuerySearch('id'));
  const [getSearch, setSearch] = useState("");
  const [isSearching, setSearching] = useState(false);
  const [list, setList] = useState(undefined);
  const [error, setError] = useState("");
  const deliveryUser = store.session?.permissions.includes(Permission.DELIVERY);
  const [checkboxActivationKey, setCheckboxActivationKey] = useState(true);
  const [checkboxHardwareId, setCheckboxHardwareId] = useState(true);
  const [checkboxCustomerInfo, setCheckboxCustomerInfo] = useState(true);
  const [checkboxPurchaseOrderId, setCheckboxPurchaseOrderId] = useState(true);
  const [checkboxUnused, setCheckboxUnused] = useState(() => true);
  const [checkboxDisabled, setCheckboxDisabled] = useState(() => false);
  const [checkboxComment, setCheckboxComment] = useState(() => false);
  const [licenceSchemaSelection, setLicenceSchemaSelection] = useState("all");

  useEffect(() => {
    const d = Dispatcher.register(payload => {
      if (payload.contentType === FluxEvent.URL_CHANGED) {
        setId(Util.getQuerySearch('id'))
      }
    });

    return () => {
      Dispatcher.unregister(d);
    };
  }, []);

  const search = e => {
    e.preventDefault();
    setSearching(true)
    UlpsPortalApiClient.getLicences(getSearch, checkboxActivationKey, checkboxHardwareId, checkboxCustomerInfo, checkboxPurchaseOrderId, checkboxUnused, checkboxDisabled, checkboxComment, licenceSchemaSelection)
      .then(r => {
        setList(r);
        setError("");
      })
      .catch(e => setError(e))
      .finally( () => setSearching(false));
  }


  if (id) {
    return <LicenceDetails id={id}/>
  }

  return <>
    <h2>ULPS Licence Search</h2>
    <br/>
    <form onSubmit={search}>
      <InputGroup className="mb-2">
        <InputGroup.Prepend>
          <InputGroup.Text>Search for Licence</InputGroup.Text>
        </InputGroup.Prepend>
        <Form.Control value={getSearch} placeholder={"Licence key, contact name, etc."}
                      onChange={e => setSearch(e.target.value)}/>
        <InputGroup.Append>
          {
            isSearching ? <Button disabled>Searching...</Button> : <Button type={"submit"}>Search</Button>
          }
        </InputGroup.Append>
      </InputGroup>
      <div id="search">
        <div className="mb-2"><strong>Search in:</strong></div>

        <div className="d-flex flex-wrap gap-3">
          <div className="inputGroupLike">
            <input
              type="checkbox"
              id="activation-key"
              checked={checkboxActivationKey}
              onChange={() => setCheckboxActivationKey(!checkboxActivationKey)}
            />
            <label htmlFor="activation-key">Activation Key</label>
          </div>

          <div className="inputGroupLike">
            <input
              type="checkbox"
              id="hardware-id"
              checked={checkboxHardwareId}
              onChange={() => setCheckboxHardwareId(!checkboxHardwareId)}
            />
            <label htmlFor="hardware-id">Hardware ID</label>
          </div>

          <div className="inputGroupLike">
            <input
              type="checkbox"
              id="customer-info"
              checked={checkboxCustomerInfo}
              onChange={() => setCheckboxCustomerInfo(!checkboxCustomerInfo)}
            />
            <label htmlFor="customer-info">
              <abbr title="Customer details, e-mail and name">Customer Info</abbr>
            </label>
          </div>

          <div className="inputGroupLike">
            <input
              type="checkbox"
              id="purchase-order"
              checked={checkboxPurchaseOrderId}
              onChange={() => setCheckboxPurchaseOrderId(!checkboxPurchaseOrderId)}
            />
            <label htmlFor="purchase-order">Purchase Order ID</label>
          </div>

          <div className="inputGroupLike">
            <input
              type="checkbox"
              id="unused"
              checked={checkboxUnused}
              onChange={() => setCheckboxUnused(!checkboxUnused)}
            />
            <label htmlFor="unused">Unused Licences</label>
          </div>
                <div className="inputGroupLike">
            <input
              type="checkbox"
              id="disabled"
              checked={checkboxDisabled}
              onChange={() => setCheckboxDisabled(!checkboxDisabled)}
            />
            <label htmlFor="disabled">Disabled Licences</label>
          </div>

          <div className="inputGroupLike">
            <input
              type="checkbox"
              id="comment"
              checked={checkboxComment}
              onChange={() => setCheckboxComment(!checkboxComment)}
            />
            <label htmlFor="comment">Comment</label>
          </div>
          <div className="d-flex align-items-center">
          <Form.Control
            as="select"
            value={licenceSchemaSelection}
            onChange={e => setLicenceSchemaSelection(e.target.value)}
            aria-label="licence-schema-select"
            style={{
              backgroundColor: "#e9ecef",
              color: "#000",
              minWidth: "200px",
              height: "38px",
              padding: "6px 12px",
              border: "1px solid #ced4da",
              borderRadius: "0.25rem",
              marginBottom: "6px",
              marginLeft: "5px",
            }}
          >
            <option value="all">All licenceSchema</option>
            <option value="iris-plus-professional-offline">iris-plus-professional-offline</option>
            <option value="ualarm-offline">ualarm-offline</option>
            <option value="ufaas-offline">ufaas-offline</option>
            <option value="event-washer-offline">event-washer-offline</option>
          </Form.Control>
          </div>
        </div>
      </div>
    </form>
    <br/>

    {
      error ? <Alert variant={"danger"}>
          {error.message}
        </Alert> :
        list ? <LicenceTable licences={list} showPurchaseOrderId={true}/>: null
    }

  </>;
}
